import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ResourcesPage from "./pages/ResourcesPage";
import CorporateTrainingPage from "./pages/CorporateTrainingPage";
import MedtronicLandingPage from "./pages/MedtronicLandingPage";
import ErnstYoungLandingPage from "./pages/ErnstYoungLandingPage";
import PhonemeLibraryPage from "./pages/PhonemeLibraryPage";
import SpeakRight101Page from "./pages/SpeakRight101Page";
import PhonemeCardPage from "./pages/PhonemeCardPage";
import VocalLabPage from "./pages/VocalLabPage";
import SoundOfAuthorityPage from "./pages/SoundOfAuthorityPage";
import AdminLecturesPage from "./pages/AdminLecturesPage";
import PhonemeAdminPage from "./pages/PhonemeAdminPage";
import PhonemeAdminEditorPage from "./pages/PhonemeAdminEditorPage";
import PhonemeCmsHelpPage from "./pages/PhonemeCmsHelpPage";
import PhonemeAudioStudioPage from "./pages/PhonemeAudioStudioPage";
import LoginPage from "./pages/LoginPage";
import MembersAreaPage from "./pages/MembersAreaPage";
import AdminPage from "./pages/AdminPage";
import SettingsPage from "./pages/SettingsPage";
import LevelTestPage from "./pages/LevelTestPage";
import VowelTourPage from "./pages/VowelTourPage";
import ConsonantTourPage from "./pages/ConsonantTourPage";
import CrmPage from "./pages/CrmPage";
import OfferPublicPage from "./pages/OfferPublicPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import MesPianoLanding from "./pages/MesPianoLanding";
import MesAdmin from "./pages/MesAdmin";
import { AdminNotificationCenter } from "./components/admin/AdminNotificationCenter";
import { ReturnToLecture } from "./components/lecture/ReturnToLecture";

const EMBEDDED = window.self !== window.top;
import { AdminTopBar } from "./components/admin/AdminTopBar";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";

// Il vecchio link di ANTEPRIMA /level-test è stato reso irraggiungibile (condiviso per errore).
// Su host di preview mostra "non disponibile"; in produzione la pagina resta attiva.
const IS_PREVIEW =
  typeof window !== "undefined" &&
  window.location.hostname.includes("preview.emergentagent.com");

function LevelTestRoute() {
  if (IS_PREVIEW) {
    return (
      <div
        data-testid="level-test-unavailable"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0b1220",
          color: "#e2e8f0",
          padding: "24px",
          textAlign: "center",
          fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
        }}
      >
        <div style={{ maxWidth: 460 }}>
          <h1 style={{ fontSize: 26, fontWeight: 800, margin: "0 0 12px" }}>
            Pagina non disponibile
          </h1>
          <p style={{ fontSize: 15, lineHeight: 1.6, color: "#94a3b8", margin: 0 }}>
            Questo indirizzo non è più attivo. Per favore utilizza il link ufficiale
            fornito da VocalFitness.
          </p>
        </div>
      </div>
    );
  }
  return <LevelTestPage />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
          <BrowserRouter>
            {!EMBEDDED && <AdminTopBar />}
            {!EMBEDDED && <AdminNotificationCenter />}
            {!EMBEDDED && <ReturnToLecture />}
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/risorse" element={<ResourcesPage />} />
              <Route path="/corporate-training" element={<CorporateTrainingPage />} />
              <Route path="/speak-right-medtronic" element={<MedtronicLandingPage />} />
              <Route path="/speak-right-ey" element={<ErnstYoungLandingPage />} />
              <Route path="/proposta-ey" element={<ErnstYoungLandingPage />} />
              <Route path="/speak-right-101" element={<SpeakRight101Page />} />
              <Route path="/lms/phonemes" element={<PhonemeLibraryPage />} />
              <Route path="/lms/vocal-lab" element={<VocalLabPage />} />
              <Route path="/sound-of-authority" element={<SoundOfAuthorityPage />} />
              <Route path="/lms/phoneme/:id" element={<PhonemeCardPage />} />
              <Route path="/lms/phoneme" element={<PhonemeCardPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/area-clienti" element={<MembersAreaPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/phonemes" element={<PhonemeAdminPage />} />
              <Route path="/admin/lectures" element={<AdminLecturesPage />} />
              <Route path="/admin/phonemes/new" element={<PhonemeAdminEditorPage />} />
              <Route path="/admin/phonemes/:id" element={<PhonemeAdminEditorPage />} />
              <Route path="/admin/help/phoneme-cms" element={<PhonemeCmsHelpPage />} />
              <Route path="/admin/audio-studio" element={<PhonemeAudioStudioPage />} />
              <Route path="/impostazioni" element={<SettingsPage />} />
              <Route path="/level-test" element={<LevelTestRoute />} />
              <Route path="/scopri-il-tuo-livello" element={<LevelTestPage />} />
              <Route path="/lezioni/vocali-rp-us" element={<VowelTourPage />} />
              <Route path="/lezioni/consonanti-rp-us" element={<ConsonantTourPage />} />
              <Route path="/crm" element={<CrmPage />} />
              <Route path="/offerta/:token" element={<OfferPublicPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/mes-pianoforte" element={<MesPianoLanding />} />
              <Route path="/mes-admin" element={<MesAdmin />} />
            </Routes>
          </BrowserRouter>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;